export const convertFilterToPaginateQueryParams = (filters: any): string =>
  Object.entries(filters).reduce<string>((filterString, [filterKey, filterValue]) => {
    if ((Array.isArray(filterValue) && !filterValue.length) || !filterValue) {
      return filterString;
    }
    return (filterString += `&filter.${filterKey}=${filterValue}`);
  }, '');
